import { styled } from "@mui/material/styles";
import { Stack, Typography, Checkbox } from "@mui/material";

export const StyledCheckbox = styled(Checkbox, {
  shouldForwardProp: (prop) => !["greyed"].includes(prop),
})(({ theme, greyed }) => ({
  padding: 0,
  margin: 0,
  ...(greyed
    ? {
        "&.MuiSwitchBase-root, &.Mui-checked": {
          color: "grey !important",
          svg: { rect: { fill: theme.palette.hubColors.greyLight } },
        },
      }
    : {}),
}));

export const StyledShell = styled(Stack)({
  flex: 1,
  overflowY: "auto",
  padding: "24px 32px 48px",
});

export const StyledFormCard = styled(Stack)(({ theme }) => ({
  maxWidth: 1000,
  width: "100%",
  margin: "0 auto",
  background: theme.palette?.hubColors.white,
  borderRadius: 16,
  border: `1px solid ${theme.palette?.hubColors?.greyLight}`,
}));

export const StyledHero = styled(Stack)(({ theme }) => ({
  flexDirection: "row",
  alignItems: "center",
  gap: 20,
  padding: "20px 28px",
  borderBottom: `1px solid ${theme.palette?.hubColors?.greyLight}`,
  background: theme.palette?.hubColors?.greyLighter,
  borderRadius: "16px 16px 0 0",
}));

export const StyledSectionLabel = styled(Typography)(({ theme }) => ({
  fontSize: 11,
  fontWeight: 600,
  letterSpacing: "0.06em",
  textTransform: "uppercase",
  color: theme.palette?.hubColors?.grey,
  padding: "20px 28px 8px",
}));

export const StyledFormRow = styled(Stack, {
  shouldForwardProp: (prop) => !["column"].includes(prop),
})(({ theme, column }) => ({
  display: "grid",
  gridTemplateColumns: column ? "1fr" : "260px 1fr",
  alignItems: "start",
  gap: column ? 15 : 32,
  padding: "16px 28px",
  borderTop: `1px solid ${theme.palette?.hubColors?.greyLight}`,
  width: "100%",
}));

export const StyledRowMeta = styled(Stack)({
  gap: 2,
  justifySelf: "start",
});

export const StyledRowLabel = styled(Typography)(({ theme }) => ({
  fontSize: 13,
  fontWeight: 600,
  color: theme.palette.hubColors.greyDark,
}));

export const StyledRowHelper = styled(Typography)(({ theme }) => ({
  fontSize: 12,
  color: theme.palette.hubColors.greyShade,
}));

export const StyledRowInput = styled(Stack, {
  shouldForwardProp: (prop) => !["column"].includes(prop),
})(({ column }) => ({
  width: "100%",
  alignItems: column ? "start" : "end",
  justifySelf: column ? "start" : "end",
  ".MuiFormControl-root, .MuiAutocomplete-root": {
    width: "100%",
  },
  ".MuiFormControlLabel-root": {
    justifyContent: "end",
  },
}));

export const StyledFooter = styled(Stack)(({ theme }) => ({
  flexDirection: "row",
  justifyContent: "flex-end",
  gap: 12,
  padding: "20px 28px",
  borderTop: `1px solid ${theme.palette?.hubColors?.greyLight}`,
  background: theme.palette?.hubColors?.greyLighter,
  borderRadius: "0px 0px 16px 16px",
}));

const MATRIX_TEMPLATE = "1fr 80px 80px 80px 80px";

export const StyledMatrixGroupLabel = styled(Typography)(({ theme }) => ({
  fontSize: 11,
  fontWeight: 700,
  letterSpacing: "0.06em",
  textTransform: "uppercase",
  color: theme.palette?.hubColors?.grey,
  padding: "16px 28px 4px",
  borderTop: `1px solid ${theme.palette?.hubColors?.greyLight}`,
  background: theme.palette?.hubColors?.greyLightest,
}));

export const StyledMatrixHeader = styled(Stack)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: MATRIX_TEMPLATE,
  gap: 8,
  alignItems: "center",
  padding: "8px 28px",
  borderTop: `1px solid ${theme.palette?.hubColors?.greyLight}`,
  background: theme.palette?.hubColors?.greyLightest,
}));

export const StyledMatrixHeaderCell = styled(Typography)(({ theme }) => ({
  fontSize: 11,
  fontWeight: 600,
  textTransform: "uppercase",
  letterSpacing: "0.05em",
  textAlign: "center",
  color: theme.palette?.hubColors?.grey,
}));

export const StyledMatrixCol = styled("div")({});

export const StyledMatrixBodyRow = styled(Stack)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: MATRIX_TEMPLATE,
  gap: 8,
  alignItems: "center",
  padding: "12px 28px",
  borderTop: `1px solid ${theme.palette?.hubColors?.greyLight}`,
}));

export const StyledMatrixCell = styled("div")({
  display: "flex",
  justifyContent: "center",
});
